import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { contactsService } from '../services/contacts.service';
import { ContactRequest, CONTACT_STATUS_LABELS } from '../types/contact';
import { getErrorMessage } from '../utils/error';
import { formatDate } from '../utils/format';
import '../styles/CandidatsPage.css';
import '../styles/ContactsAgency.css';

/**
 * Espace agence — LISTE des contacts assignés. Le détail est une page.
 */
const AgencyContactsPage: React.FC = () => {
  const navigate = useNavigate();
  const [contacts, setContacts] = useState<ContactRequest[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setContacts(await contactsService.listAgencyContacts());
    } catch (err) {
      setError(getErrorMessage(err, 'Erreur lors du chargement des contacts'));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  if (loading) {
    return <div className="loading">Chargement...</div>;
  }

  return (
    <div className="candidats-page">
      <div className="candidats-header">
        <h2>Contacts assignés</h2>
      </div>

      {error && <div className="candidats-error">{error}</div>}

      {contacts.length === 0 ? (
        <div className="socle-vide">
          <p className="socle-vide-titre">Aucun contact assigné</p>
          <p className="socle-vide-aide">
            Les demandes qu'un propriétaire vous confie apparaissent ici, avec le
            message qu'il vous a adressé. Vous y consignez ensuite chaque échange.
          </p>
        </div>
      ) : (
        <div className="contacts-table-container">
        <table className="candidats-table">
          <thead>
            <tr>
              <th>Nom</th>
              <th>Email</th>
              <th>Téléphone</th>
              <th>Statut</th>
              <th>Assigné le</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {contacts.map((c) => (
              <tr
                key={c.id}
                className="candidats-row"
                onClick={() => navigate(`/agency/contacts/${c.id}`)}
              >
                <td>{c.name}</td>
                <td>{c.email}</td>
                <td>{c.phone || '—'}</td>
                <td>{CONTACT_STATUS_LABELS[c.status] || c.status}</td>
                <td>{c.assignedAt ? formatDate(c.assignedAt) : '—'}</td>
                <td className="cx-actions" onClick={(e) => e.stopPropagation()}>
                  <button
                    className="btn-action btn-secondary"
                    onClick={() => navigate(`/agency/contacts/${c.id}`)}
                  >
                    Ouvrir
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      )}
    </div>
  );
};

export default AgencyContactsPage;
